import React from 'react';

const LogoTeams = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#6264A7"/>
    <circle cx="18" cy="18" r="6" fill="#6264A7"/>
    <circle cx="30" cy="18" r="6" fill="#6264A7"/>
    <circle cx="18" cy="30" r="6" fill="#6264A7"/>
    <circle cx="30" cy="30" r="6" fill="#6264A7"/>
    <circle cx="18" cy="18" r="4" fill="white"/>
    <circle cx="30" cy="18" r="4" fill="white"/>
    <circle cx="18" cy="30" r="4" fill="white"/>
    <circle cx="30" cy="30" r="4" fill="white"/>
  </svg>
);

export default LogoTeams;
